import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const bgColors = [
    'bg-accent-100/70', 'bg-primary-100/70', 'bg-secondary-100/70', 'bg-accent-50/70',
    'bg-primary-50/70', 'bg-secondary-50/70', 'bg-accent-100/70', 'bg-primary-100/70',
    'bg-secondary-100/70', 'bg-accent-50/70', 'bg-primary-50/70', 'bg-secondary-50/70',
    'bg-accent-100/70', 'bg-primary-100/70',
  ];

  return (
    <section className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3">
            Browse by Category
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Most Popular <span className="italic text-primary-500">Kakobuy Spreadsheet</span> Categories
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl">
            Explore our comprehensive directory of product categories — each with verified spreadsheet links, updated daily for the best shopping experience.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 card-hover cursor-pointer"
            >
              <div className={`relative w-full aspect-[4/3] ${bgColors[index % bgColors.length]} overflow-hidden`}>
                <img
                  src={cat.image}
                  alt={`Kakobuy Spreadsheet ${cat.name}`}
                  title={`Kakobuy Spreadsheet - ${cat.name} Category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-semibold text-primary-600 group-hover:gap-2 transition-all">
                  <span className="whitespace-nowrap">View Spreadsheet</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}